export const costs = [
  'Noches en vela buscando cómo traducir conceptos de geología complejos a un lenguaje que tus alumnos puedan entender.',
  'Clases improvisadas porque no encontraste un material claro y listo para usar a tiempo.',
  'Alumnos desconectados que sienten que la geología no tiene nada que ver con ellos ni con su carrera.',
  'Silencios incómodos cuando un alumno pregunta cómo identificar un mineral o por qué tiembla la tierra y no tienes una respuesta clara a mano.',
  'Fines de semana perdidos armando planificaciones, proyectos técnicos y evaluaciones desde cero una y otra vez.',
  'Incertidumbre sobre cómo enseñar tectónica de placas, estratigrafía o fosilización sin los recursos adecuados.',
];
